var map = {
	"./10s": "./src/Assets/Animation/10s.json",
	"./10s.json": "./src/Assets/Animation/10s.json",
	"./20s": "./src/Assets/Animation/20s.json",
	"./20s.json": "./src/Assets/Animation/20s.json",
	"./30s": "./src/Assets/Animation/30s.json",
	"./30s.json": "./src/Assets/Animation/30s.json",
	"./Blitz": "./src/Assets/Animation/Blitz.json",
	"./Blitz.json": "./src/Assets/Animation/Blitz.json",
	"./Bullet": "./src/Assets/Animation/Bullet.json",
	"./Bullet.json": "./src/Assets/Animation/Bullet.json",
	"./CaissaHello_animation.riv": "./src/Assets/Animation/CaissaHello_animation.riv",
	"./CaissaSuccess_animation.riv": "./src/Assets/Animation/CaissaSuccess_animation.riv",
	"./Calculation_Trainer/Calculation_Trainer": "./src/Assets/Animation/Calculation_Trainer/Calculation_Trainer.json",
	"./Calculation_Trainer/Calculation_Trainer.json": "./src/Assets/Animation/Calculation_Trainer/Calculation_Trainer.json",
	"./Challenge_a_friend.riv": "./src/Assets/Animation/Challenge_a_friend.riv",
	"./Classical": "./src/Assets/Animation/Classical.json",
	"./Classical.json": "./src/Assets/Animation/Classical.json",
	"./Didnt_find_any_opponent.riv": "./src/Assets/Animation/Didnt_find_any_opponent.riv",
	"./Intuition_Trainer/Intuition_Trainer": "./src/Assets/Animation/Intuition_Trainer/Intuition_Trainer.json",
	"./Intuition_Trainer/Intuition_Trainer.json": "./src/Assets/Animation/Intuition_Trainer/Intuition_Trainer.json",
	"./Play_against_Caissa_Bot.riv": "./src/Assets/Animation/Play_against_Caissa_Bot.riv",
	"./Play_random_opponent.riv": "./src/Assets/Animation/Play_random_opponent.riv",
	"./Practice_from_a_position.riv": "./src/Assets/Animation/Practice_from_a_position.riv",
	"./Rapid": "./src/Assets/Animation/Rapid.json",
	"./Rapid.json": "./src/Assets/Animation/Rapid.json",
	"./Search": "./src/Assets/Animation/Search.json",
	"./Search.json": "./src/Assets/Animation/Search.json",
	"./Snail": "./src/Assets/Animation/Snail.json",
	"./Snail.json": "./src/Assets/Animation/Snail.json",
	"./Solve_Puzzles/Solve_Puzzles": "./src/Assets/Animation/Solve_Puzzles/Solve_Puzzles.json",
	"./Solve_Puzzles/Solve_Puzzles.json": "./src/Assets/Animation/Solve_Puzzles/Solve_Puzzles.json",
	"./Square_Trainer/Square_training": "./src/Assets/Animation/Square_Trainer/Square_training.json",
	"./Square_Trainer/Square_training.json": "./src/Assets/Animation/Square_Trainer/Square_training.json",
	"./Start_new_game/v1": "./src/Assets/Animation/Start_new_game/v1.json",
	"./Start_new_game/v1.json": "./src/Assets/Animation/Start_new_game/v1.json",
	"./Start_new_game/v2": "./src/Assets/Animation/Start_new_game/v2.json",
	"./Start_new_game/v2.json": "./src/Assets/Animation/Start_new_game/v2.json",
	"./caissa_animation.riv": "./src/Assets/Animation/caissa_animation.riv",
	"./challenge_animation.riv": "./src/Assets/Animation/challenge_animation.riv",
	"./challenge_wait": "./src/Assets/Animation/challenge_wait.json",
	"./challenge_wait.json": "./src/Assets/Animation/challenge_wait.json",
	"./chessboardLoader": "./src/Assets/Animation/chessboardLoader.json",
	"./chessboardLoader.json": "./src/Assets/Animation/chessboardLoader.json",
	"./chessboardLoader2": "./src/Assets/Animation/chessboardLoader2.json",
	"./chessboardLoader2.json": "./src/Assets/Animation/chessboardLoader2.json",
	"./circlechess_opponent_matching_animation.riv": "./src/Assets/Animation/circlechess_opponent_matching_animation.riv",
	"./didnt_respond.riv": "./src/Assets/Animation/didnt_respond.riv",
	"./error_boundary_animation": "./src/Assets/Animation/error_boundary_animation.json",
	"./error_boundary_animation.json": "./src/Assets/Animation/error_boundary_animation.json",
	"./error_page_404.lottie": "./src/Assets/Animation/error_page_404.lottie",
	"./mobileMenuIcon": "./src/Assets/Animation/mobileMenuIcon.json",
	"./mobileMenuIcon.json": "./src/Assets/Animation/mobileMenuIcon.json",
	"./rejected_your_challenge.riv": "./src/Assets/Animation/rejected_your_challenge.riv",
	"./successCheck": "./src/Assets/Animation/successCheck.json",
	"./successCheck.json": "./src/Assets/Animation/successCheck.json",
	"./under_construction": "./src/Assets/Animation/under_construction.json",
	"./under_construction.json": "./src/Assets/Animation/under_construction.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/Assets/Animation sync recursive ^\\.\\/.*$";